import { URL_CLOUD, URLHOST } from "../../Const/envConst";

export const formatUrl = (url: string | undefined, cloud = false): string =>
	url
		? url?.startsWith("http")
			? encodeURI(url)
			: `${cloud ? URL_CLOUD : URLHOST}${
					url?.startsWith("/") ? encodeURI(url) : `/${encodeURI(url)}`
			  }`
		: "";
